import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmService } from '../../../shared/confirm-dialog/confirm-dialog.service';
import { StatistikService } from '../../statistik.service';
import { ProduktivitetFormler } from '../../models/ProduktivitetFormler';
import { Observable } from 'rxjs';
import { ProduktivitetFormlerRequest } from '../statistik-produktivitet/ProduktivitetFormlerRequest';

@Component({
    selector: 'app-statistik-produktivitet-formler-modal-ui',
    templateUrl: './statistik-produktivitet-formler-modal.html',
    styleUrls: ['./statistik-produktivitet-formler-modal.scss'],
    standalone: false
})
export class StatistikProduktivitetFormlerModal implements OnInit {
    listOfFormels$: Observable<ProduktivitetFormler[]>;

    constructor(private activeModal: NgbActiveModal,
                private confirmService: ConfirmService,
                private statistikService: StatistikService) {
    }

    ngOnInit(): void {
        this.listOfFormels$ = this.statistikService.getProduktivtetFormler();
    }

    onDismiss() {
        this.activeModal.dismiss();
    }

    reloadData() {
        this.listOfFormels$ = this.statistikService.getProduktivtetFormler();
    }

    createFormel() {
        const editRequest: ProduktivitetFormlerRequest = {
            id: 123,
            betegnelse: 'Ny Custom',
            formel: 'A-B'
        };

        this.statistikService.postCreateProduktivtetFormler(editRequest).subscribe(() => {
            this.reloadData();
        }, error => {
            console.error('Error occurred: ', error);
        });
    }

    removeFormel(formel: ProduktivitetFormler): void {
        this.confirmService.question(`Er du sikker på du vil slette formelen: ${formel.betegnelse}?`, 'Accepter', 'Afvis')
            .then(confirmedDelete => {
                if (confirmedDelete) {
                    this.statistikService.postDeleteProduktivtetFormler(formel.id).subscribe(() => {
                        this.reloadData();
                    }, error => {
                        console.error('Error occurred: ', error);
                    });
                }
            });
    }

    editFormel(id: number, description: string, formula: string) {
        const editRequest: ProduktivitetFormlerRequest = {
            id: id,
            betegnelse: description,
            formel: formula
        };

        this.statistikService.postEditProduktivtetFormler(editRequest).subscribe(() => {
            this.reloadData();
        }, error => {
            console.error('Error occurred: ', error);
        });
    }
}







